// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from '../../../icon/Icon'

@Component({
    components: {Icon},
    mixins: [
        template,
    ]
})
export class TableRowCell extends Vue {

    @Prop({type: [Object, Array]})
    public row!: object

    @Prop({type: [Number, String]})
    public rowKey!: number

    @Prop()
    public col!: object

    @Prop({type: [String, Number]})
    public colKey!: string

    @Prop({type: [Object, Array]})
    public data!: any[]

    public created () {

    }
}